import React from 'react'
import { calculateAge } from 'util/date/calculateAge'
import { RegistroMChatAcompanhamentoPuericultura } from 'view/atendimentos/detail/soap/aside/acompanhamento-puericultura/model'

import { MCHAT_RESULTADOS } from '../model-mChatRf'
import { MChatRfRegistroListItem } from './MChatRfRegistroListItem'

interface MChatRegistroListItemProps {
  item: RegistroMChatAcompanhamentoPuericultura
  cidadaoDataNascimento: LocalDate
  isLastItem: boolean
  onPrint: (event: React.MouseEvent<HTMLButtonElement>, item: RegistroMChatAcompanhamentoPuericultura) => void
}

export function MChatRegistroListItem(props: Readonly<MChatRegistroListItemProps>) {
  const { item, cidadaoDataNascimento, isLastItem, onPrint } = props

  const { ageInMonths } = calculateAge(cidadaoDataNascimento, item.dataResultado)

  const { title, encaminhamento, status } = MCHAT_RESULTADOS[item.risco]

  return (
    <MChatRfRegistroListItem
      type='m-chat'
      status={status}
      title={title}
      description={encaminhamento(ageInMonths)}
      label={'ponto'.pluralizeAndConcatValue(item.pontuacao)}
      isLastItem={isLastItem}
      footerInfo={{
        atendimentoProfissionalId: item.atendimentoProfissional.id,
        dataResultado: item.dataResultado,
        lotacao: item.atendimentoProfissional.lotacao,
      }}
      onPrint={(event) => onPrint(event, item)}
      cidadaoDataNascimento={cidadaoDataNascimento}
    />
  )
}
